import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { ref } from 'vue';
import serverContextStore from '@/shared/content/server-context.store';
import httpService from '@/core/http/http.service';
import utilities from '@/shared/utilities.service';
import PdfLinkIconAndLabel from '@/shared/navigation/pdf-link/PdfLinkIconAndLabel.vue';
import { AxiosRequestConfig } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfLinkDownload',
  props: {
    url: null,
    label: null,
    isDirectLink: { type: Boolean },
    hideIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    url: string,
    label?: string,
    isDirectLink?: boolean,
    hideIcon?: boolean,
}



const isGeneratingPdf = ref(false);

const download = async(): Promise<void> => {
    isGeneratingPdf.value = true;
    try {
        const config: AxiosRequestConfig = { responseType: 'blob' };
        /* eslint-disable */
        const pdfBlob:BlobPart = props.isDirectLink
            ? await httpService.get(props.url, {}, { ...config, headers: { 'Authorization': '' } })
            : await httpService.get(`${serverContextStore.apiEndPoint}${props.url}`, {}, config);
        /* eslint-enable */
        utilities.downloadBlob(pdfBlob, `${props.label}.pdf`);
    } catch (e) {
        console.error(e);
    } finally {
        isGeneratingPdf.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    title: __props.label,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (download()), ["prevent","stop"]))
  }, [
    _renderSlot(_ctx.$slots, "default", { isGeneratingPdf: isGeneratingPdf.value }, () => [
      _createVNode(PdfLinkIconAndLabel, {
        label: __props.label,
        "hide-icon": __props.hideIcon
      }, null, 8, ["label", "hide-icon"])
    ])
  ], 8, _hoisted_1))
}
}

})